/**
 * Wraps an error that surfaces from commitReservation. Carries the metadata
 * the hook needs to decide UI behavior:
 *
 * - cause: original error (ThreeDsError, network, backend, etc.) — passed
 *   through unchanged so the hook can pattern-match on its type.
 * - mpFlow3dsLoaded: whether the MercadoPago flow loaded Stripe.js v3 during
 *   this attempt. Once v3 loads, v2 is dead globally, so the UI must force a
 *   page reload before retry. See ConfirmationPage.tsx requireReload state.
 * - processor: which payment processor was active. Used by capturePaymentError
 *   for Sentry tagging.
 */
export class CommitError extends Error {
  constructor(
    public readonly cause: unknown,
    public readonly mpFlow3dsLoaded: boolean,
    public readonly processor: 'mercadopago' | 'stripe',
  ) {
    super(cause instanceof Error ? cause.message : String(cause));
    this.name = 'CommitError';
  }
}
